export const dashboardRoutes = {
  label: "Dashboard",
  labelDisable: true,

  children: [
    {
      name: "Profile Settings",
      to: "/",
      exact: true,
      active: true,
      icon: 'user',
      perm: "Profile Settings"
      
    },
    {
      name: "User Management",
      to: "/users",
      exact: true,
      active: true,
      icon: 'user',
      perm: "Users"
      
    },
  ],
};
export const appRoutes = {
  label: "DREAMS-I Site",
  children: [
    
    {
      name: "DREAMS-I Home",
      active: true,
      icon: 'home',
      perm: "Dreams Home",
      children: [
        {
          name: "Slider",
          active: true,
          to: "/home/slider",
          perm: "Home Slider"
        },
        {
          name: "DREAMS-I Scope",
          active: true,
          to: "/home/dreams-scope",
          perm: "Dreams Scope"
        },
        {
          name: "About DREAMS-I Home",
          active: true,
          to: "/home/about-dreams-home",
          perm: "About Dreams Home"
        },
      ]
    },
    {
      name: "Leadership",
      active: true,
      icon: 'users',
      to: "/leadership",
      perm: "Leadership"
    },
    {
      name: "Core Team",
      active: true,
      icon: 'users',
      to: "/core-team",
      perm: "Core Team"
    },
    
    {
      name: "Downloads",
      // to: "/downloads",
      active: true,
      icon: "download",
      perm: "Downloads",
      
      children: [
        {
          name: "Downloads",
          to: "/downloads",
          active: true,
          perm: "Downloads",
          // icon: "download",
        },
        {
          name: "Download Categories",
          to: "/download-categories",
          active: true,
          perm: "Downloads",
          // icon: "download",
        },
      ]
    },
    
    {
      name: "Procurements",
      active: true,
      icon: "shopping-cart",
      to: "/procurements",
      perm: "Procurements",
    },
    {
      name: "News & Events",
      active: true,
      icon: "calendar-day",
      to: "/news&events",
      perm: "News & Events",
    },
    {
      name: "Jobs",
      active: true,
      icon: "tasks",
      to: "/jobs",
      perm: "Jobs",
    },
    
    {
      name: "Pages",
      active: true,
      icon: 'file',
      perm: "Pages",
      children: [
        {
          name: "About PRF",
          active: true,
          to: "/pages/about-prf",
          perm: "Pages",
        },
        {
          name: "About DREAMS-I",
          active: true,
          to: "/pages/about-dreams",
          perm: "Pages",
        },
        {
          name: "Our Cities",
          active: true,
          to: "/pages/our-cities",
          perm: "Pages",
        },
        {
          name: "Organogram",
          active: true,
          to: "/pages/organogram",
          perm: "Pages",
        },
        {
          name: "Our Initiatives",
          active: true,
          to: "/pages/our-initiatives",
          perm: "Pages",
        },
        
        {
          name: "Our Vision",
          active: true,
          to: "/pages/our-vision",
          perm: "Pages",
        },
        {
          name: "Our Mission",
          active: true,
          to: "/pages/our-mission",
          perm: "Pages",
        },
        {
          name: "Goals",
          active: true,
          to: "/pages/goals",
          perm: "Pages",
        },
        {
          name: "Objectives",
          active: true,
          to: "/pages/objectives",
          perm: "Pages",
        },
      ]
    },
  ],
};



export default [
  dashboardRoutes,
  appRoutes,
];
